/*eslint perfectionist/sort-objects: "error"*/
/* eslint-disable no-multi-str */

export const enGb = {
  actualAmount: "Actual Amount",
  beneficiariesPageDescription:
    "People or companies that can receive settlements for this customer.",
  bvnkCopyLink: "Copy Link",
  bvnkCopyLinkForCustomer:
    "Copy and share this link with the customer to continue onboarding:",
  bvnkCryptoPayments: "Stablecoin Payments Onboarding",
  bvnkDescription: "Description",
  bvnkIndustry: "Industry",
  bvnkMonthlyVolume: "Monthly Expected Volume",
  bvnkOnboardingContactAdmin:
    "To start onboarding for this customer, please contact a Volt administrator.",
  bvnkOnboardingDescription:
    "Process onboarding to start receiving money in crypto.",
  bvnkOnboardingFailure: "Failed to start onboarding. Please try again.",
  bvnkOnboardingFormDescription:
    "Complete the form below to start the onboarding process.",
  bvnkOnboardingStatusActive:
    "Onboarding is complete and the customer is active.",
  bvnkOnboardingStatusInfoRequired:
    "Additional information is required to continue onboarding.",
  bvnkOnboardingStatusPending: "Onboarding is in progress.",
  bvnkOnboardingStatusPendingAgreements:
    "Customer needs to review and accept agreements to continue.",
  bvnkOnboardingStatusRejected:
    "Onboarding was rejected. Please review details and try again.",
  bvnkOnboardingStatusVerified:
    "Customer is verified and onboarding is complete.",
  bvnkOnboardingSuccess: "Onboarding started successfully.",
  bvnkOnboardingSuccessDescription:
    "Share the hosted agreement URL with the merchant to complete signing.",
  bvnkOnboardingUnknownStatus:
    "The onboarding status is currently unknown. Please contact your administrator for assistance.",
  bvnkUseCase: "Use Case",
  bvnkUseCaseEMBEDDED_FIAT_ACCOUNTS: "Embedded Fiat Accounts",
  bvnkUseCaseEMBEDDED_STABLECOIN_WALLETS: "Embedded Stablecoin Wallets",
  bvnkUseCaseSTABLECOIN_PAYOUTS: "Stablecoin Payouts",
  bvnkViewNextStep: "Continue to Next Step",
  cancel: "Cancel",
  close: "Close",
  confirmedAt: "Confirmed at",
  country: "Country",
  createWalletButton: "Create wallet",
  createWalletFailure: "Failed to create wallet. Please try again.",
  createWalletName: "Description",
  createWalletNamePlaceholder: "e.g. Treasury USDC",
  createWalletSubmit: "Create wallet",
  createWalletSuccess: "Wallet created successfully.",
  createWalletSymbol: "Currency",
  createWalletTitle: "Create Wallet",
  createWalletType: "Type",
  customerDetailsHeader: "Details",
  customerName: "Customer {{name}}",
  customerNameCardLabel: "Customer Name",
  customerType: "Type",
  customerTypeHeader: "Customer",
  detectedAt: "Detected at",
  displayRate: "Exchange Rate",
  edit: "Edit",
  expectedAmount: "Expected Amount",
  fee: "Fee",
  firstName: "First name",
  hostedAgreementUrl: "Hosted Agreement URL",
  lastName: "Last name",
  legalName: "Legal name",
  loading: "Loading...",
  network: "Network",
  networkFee: "Network Fee",
  notConfigured: "Not configured",
  onboarding: "Onboarding",
  onboardingRequired:
    "Onboarding must be completed before you can access this feature. Please complete the onboarding process first.",
  refundAlert: "This payment has been refunded.",
  refundAlreadyActive: "A refund is already in progress for this payment.",
  refundDestination: "Refund Via",
  refundDestinationEmail: "Email",
  refundDestinationWallet: "Wallet Address",
  refundDialogDescription:
    "Are you sure you want to start a refund for this payment? This action will refund the full payment amount.",
  refundDialogTitle: "Start Refund",
  refundFailureReason: "Failure Reason",
  refundInfoHeader: "Refund",
  refundPayerEmail: "Payer Email",
  refundReason: "Reason (optional)",
  refundReasonLabel: "Refund Reason",
  refundRequestedBy: "Requested By",
  refundSourceWallet: "Source Wallet",
  refundStartButton: "Start Refund",
  refundStartedSuccess:
    "Refund started successfully. A refund link has been sent to {{email}}.",
  refundStartedSuccessWallet:
    "Refund started successfully. Funds will be sent to the provided wallet address.",
  refundStatusCancelled: "Cancelled",
  refundStatusCompleted: "Completed",
  refundStatusFailed: "Failed",
  refundStatusPending: "Pending",
  refundStatusProcessing: "Processing",
  refundStatusUnknown: "Unknown",
  refundTargetAddress: "Target Wallet Address",
  refundTargetAddressColumn: "Target Address",
  refundTargetAddressHelper:
    "The refund will be sent as {{currency}} on {{network}}.",
  refundTargetAddressInvalid:
    "This address is not valid for the payment's currency and network.",
  refundTargetAddressRequired: "Wallet address is required.",
  refundTargetAddressTooLong: "Wallet address must be 128 characters or fewer.",
  refundWallet: "Refund Wallet",
  runSettlementButton: "Manual Settlement",
  runSettlementFailure: "Failed to start settlement. Please try again.",
  runSettlementSubmit: "Run settlement",
  runSettlementSuccess: "Settlement has been started.",
  runSettlementTitle: "Manual Settlement",
  save: "Save",
  selectCustomer: "Select a customer",
  selectCustomerDescription:
    "To view stablecoin features, please select a customer using the global filter.",
  settlementConfigAmount: "Settlement Amount",
  settlementConfigAmountAll: "Entire wallet balance",
  settlementConfigBankAccount: "Bank Account",
  settlementConfigBeneficiary: "Beneficiary",
  settlementConfigConfigure: "Configure",
  settlementConfigCreate: "Create Settlement Schedule",
  settlementConfigCreateFailure:
    "Failed to create settlement configuration. Please try again.",
  settlementConfigCreateSuccess:
    "Settlement configuration created successfully.",
  settlementConfigCurrency: "Currency",
  settlementConfigDayOfMonth: "Day of Month",
  settlementConfigDayOfWeek: "Day of Week",
  settlementConfigDescription:
    "Configure automated settlement schedule for this customer.",
  settlementConfigDestinationType: "Destination Type",
  settlementConfigDestinationTypeBank: "Bank Account",
  settlementConfigDestinationTypeCrypto: "Crypto Wallet",
  settlementConfigDisabled: "Settlement schedule is currently disabled.",
  settlementConfigEdit: "Edit",
  settlementConfigEditDescription:
    "Update the automated settlement schedule for this customer.",
  settlementConfigEnabled: "Settlement schedule is active.",
  settlementConfigFrequency: "Frequency",
  settlementConfigFrequencyDaily: "Daily",
  settlementConfigFrequencyMonthly: "Monthly",
  settlementConfigFrequencyWeekly: "Weekly",
  settlementConfigLastRun: "Last Run",
  settlementConfigMethod: "Settlement Method",
  settlementConfigNextRun: "Next Run",
  settlementConfigNoConfig: "No settlement schedule configured.",
  settlementConfigPrimaryTime: "Primary Settlement Time (UTC)",
  settlementConfigRunFailure:
    "Failed to trigger manual settlement. Please try again.",
  settlementConfigRunManual: "Run Manual Settlement",
  settlementConfigRunSuccess:
    "Manual settlement started successfully. Workflow ID: {{workflowId}}",
  settlementConfigSchedule: "Settlement Schedule",
  settlementConfigSecondaryTime: "Secondary Settlement Time (UTC)",
  settlementConfigSettlementAddress: "Settlement Address",
  settlementConfigSettlementAll: "Settle entire wallet balance",
  settlementConfigSettlementIfInsufficient:
    "If insufficient balance, settle available amount",
  settlementConfigSettlementWallet: "Crypto Wallet",
  settlementConfigTime: "Time",
  settlementConfigTimezone: "Timezone",
  settlementConfigTitle: "Settlement Configuration",
  settlementConfigToggleFailure:
    "Failed to toggle settlement configuration. Please try again.",
  settlementConfigToggleSuccess:
    "Settlement configuration updated successfully.",
  settlementConfigUpdateFailure:
    "Failed to update settlement configuration. Please try again.",
  settlementConfigUpdateSuccess:
    "Settlement configuration updated successfully.",
  settlementConfigWallet: "Source Wallet",
  settlementDestinationsBankAccountsTab: "Bank accounts",
  settlementDestinationsBeneficiariesTab: "Beneficiaries",
  settlementDestinationsCryptoWalletsTab: "Crypto wallets",
  settlementDestinationsDescription:
    "Manage the beneficiaries, bank accounts and crypto wallets that can be used as settlement destinations for each wallet.",
  settlementDestinationsPageDescription:
    "Bank accounts and crypto wallets that can be selected as settlement destinations for this customer.",
  settlementDestinationsTab: "Settlement destinations",
  settlementDestinationsTitle: "Settlement destinations",
  settlementDetailsAmountCents: "Amount (cents)",
  settlementDetailsBvnkSettlementId: "Settlement ID",
  settlementDetailsCreatedAt: "Created At",
  settlementDetailsCurrency: "Currency",
  settlementDetailsErrorMessage: "Error Message",
  settlementDetailsId: "ID",
  settlementDetailsMethod: "Method",
  settlementDetailsReference: "Reference",
  settlementDetailsRequiredAction: "Required Action",
  settlementDetailsSettlementConfigId: "Settlement Config ID",
  settlementDetailsStatus: "Status",
  settlementDetailsTitle: "Settlement Details",
  settlementDetailsUpdatedAt: "Updated At",
  settlements: "Settlements",
  settlementSetupBankAccountCreateFailure:
    "Failed to create bank account. Please try again.",
  settlementSetupBankAccountCreateSuccess: "Bank account created successfully.",
  settlementSetupBankAccountFormCreateTitle: "Add Bank Account",
  settlementSetupBankAccountFormEditTitle: "Edit Bank Account",
  settlementSetupBankAccountNumber: "Account Number / IBAN",
  settlementSetupBankAccountsCardDescription:
    "Bank accounts that can be selected as a settlement destination.",
  settlementSetupBankAccountsCardTitle: "Bank Accounts",
  settlementSetupBankAccountsTitle: "Settlement Destinations",
  settlementSetupBankAccountType: "Account Type",
  settlementSetupBankAccountUpdateFailure:
    "Failed to update bank account. Please try again.",
  settlementSetupBankAccountUpdateSuccess: "Bank account updated successfully.",
  settlementSetupBankCurrency: "Currency",
  settlementSetupBankIdentificationCode: "Identification Code (BIC/SWIFT)",
  settlementSetupBankNid: "NID / Routing Number",
  settlementSetupBeneficiariesCardDescription:
    "People or companies that can receive settlements.",
  settlementSetupBeneficiariesCardTitle: "Beneficiaries",
  settlementSetupBeneficiariesTitle: "Beneficiaries",
  settlementSetupBeneficiaryCreateFailure:
    "Failed to create beneficiary. Please try again.",
  settlementSetupBeneficiaryCreateSuccess: "Beneficiary created successfully.",
  settlementSetupBeneficiaryDateOfBirth: "Date of Birth",
  settlementSetupBeneficiaryFormCreateTitle: "Add Beneficiary",
  settlementSetupBeneficiaryFormEditTitle: "Edit Beneficiary",
  settlementSetupBeneficiaryName: "Name",
  settlementSetupBeneficiaryRegistrationNumber: "Registration Number",
  settlementSetupBeneficiaryRelationshipType: "Relationship Type",
  settlementSetupBeneficiaryType: "Beneficiary Type",
  settlementSetupBeneficiaryUpdateFailure:
    "Failed to update beneficiary. Please try again.",
  settlementSetupBeneficiaryUpdateSuccess: "Beneficiary updated successfully.",
  settlementSetupCreateBankAccount: "Create Bank Account",
  settlementSetupCreateBeneficiary: "Create Beneficiary",
  settlementSetupCreateCryptoWallet: "Create Crypto Wallet",
  settlementSetupCryptoWalletAddress: "Wallet Address",
  settlementSetupCryptoWalletAddressInvalid: "Invalid wallet address",
  settlementSetupCryptoWalletCreateFailure:
    "Failed to create crypto wallet. Please try again.",
  settlementSetupCryptoWalletCreateSuccess:
    "Crypto wallet created successfully.",
  settlementSetupCryptoWalletCurrency: "Wallet Currency",
  settlementSetupCryptoWalletFormCreateTitle: "Add Crypto Wallet",
  settlementSetupCryptoWalletFormEditTitle: "Edit Crypto Wallet",
  settlementSetupCryptoWalletProtocol: "Protocol",
  settlementSetupCryptoWalletsCardDescription:
    "Crypto wallets that can be selected as a settlement destination.",
  settlementSetupCryptoWalletsCardTitle: "Crypto Wallets",
  settlementSetupCryptoWalletUpdateFailure:
    "Failed to update crypto wallet. Please try again.",
  settlementSetupCryptoWalletUpdateSuccess:
    "Crypto wallet updated successfully.",
  settlementSetupDescription:
    "Create beneficiaries and settlement destinations once, then reuse them in settlement configuration.",
  settlementSetupNoBankAccounts: "No bank accounts created yet.",
  settlementSetupNoBeneficiaries: "No beneficiaries created yet.",
  settlementSetupNoCryptoWallets: "No crypto wallets created yet.",
  settlementSetupShowBankAccountForm: "Add Bank Account",
  settlementSetupShowBeneficiaryForm: "Add Beneficiary",
  settlementSetupShowCryptoWalletForm: "Add Crypto Wallet",
  settlementSetupTitle: "Settlement Setup",
  settlementsListAmount: "Amount",
  settlementsListCreatedAt: "Created At",
  settlementsListCurrency: "Currency",
  settlementsListEmpty: "No settlements found.",
  settlementsListMethod: "Method",
  settlementsListReference: "Reference",
  settlementsListStatus: "Status",
  settlementsListTitle: "Settlements",
  stablecoins: "Stablecoins",
  stablecoinsPaymentDetails: "Payment Details",
  stablecoinsPaymentInfo: "Payment Info",
  stablecoinsPayments: "Payments",
  stablecoinsPaymentsCancelled: "Cancelled",
  stablecoinsPaymentsCompleted: "Completed",
  stablecoinsPaymentsExpired: "Expired",
  stablecoinsPaymentsFailed: "Failed",
  stablecoinsPaymentsNew: "New",
  stablecoinsPaymentsOnHold: "On hold",
  stablecoinsPaymentsOverpaid: "Overpaid",
  stablecoinsPaymentsProcessing: "Processing",
  stablecoinsPaymentsStatusUnknown: "Unknown",

  stablecoinsPaymentsUnderpaid: "Underpaid",
  startOnboarding: "Start Onboarding",
  status: "Status",
  statusConfirmed: "Confirmed",
  statusDetected: "Detected",
  statusExpired: "Expired",
  statusFilled: "Filled",
  statusLate: "Late",
  statusOnHold: "On hold",
  statusOpen: "Open",
  statusPartiallyFilled: "Partially filled",
  statusPending: "Pending",
  statusUnknown: "Unknown",
  stbAmount: "Amount",
  stbConfirmed: "Confirmed",
  stbCreatedAt: "Date (UTC)",
  stbCurrency: "CCY",
  stbExpiresAt: "Expires at",
  stbFiatPayment: "Fiat Payment",
  stbFiatPaymentSynced: "Fiat payment synced",
  stbNoPayments: "No payments",
  stbPaymentId: "Payment ID",
  stbPaymentSummary: "Stablecoins Payment Summary",
  stbRefunded: "Refunded",
  stbRefundedYes: "Yes",
  stbSearchByPaymentId: "Search by Payment ID",
  stbWeAreWaitingForYourFirstPayment:
    "We're waiting for your first stablecoin payment",
  targetOutcome: "Outcome",
  token: "Token",
  transactionDetails: "Transaction Details",
  transactionsColumnDate: "Date (UTC)",
  transactionsColumnReference: "Reference",
  transactionsColumnSourceWallet: "Source wallet",
  transactionsColumnTargetWallet: "Target wallet",
  transactionsFilterAmount: "Amount",
  transactionsFilterCurrency: "Currency",
  transactionsFilterCustomer: "Customer",
  transactionsFilterType: "Type",
  transactionsFilterWallet: "Wallet",
  transactionsListEmptyDescription:
    "There are no money movements for this customer yet.",
  transactionsListEmptyFilteredDescription:
    "No payments match the selected filters.",
  transactionsListEmptyHeader: "No payments",
  transactionsListTitle: "Payments",
  transactionStatusCancelled: "Cancelled",
  transactionStatusCompleted: "Completed",
  transactionStatusFailed: "Failed",
  transactionStatusPending: "Pending",
  transactionStatusProcessing: "Processing",
  transactionStatusReturned: "Returned",
  transactionStatusUnknown: "Unknown",
  transactionTypePayment: "Payment",
  transactionTypePayout: "Payout",
  transactionTypeRefund: "Refund",
  transactionTypeSettlement: "Settlement",
  transactionTypeTransfer: "Transfer",
  transferDetailsAmountIn: "Amount sent",
  transferDetailsAmountOut: "Amount received",
  transferDetailsCreatedAt: "Created at",
  transferDetailsFailureReason: "Failure reason",
  transferDetailsFee: "Fee",
  transferDetailsId: "Transfer ID",
  transferDetailsKind: "Kind",
  transferDetailsRate: "Rate",
  transferDetailsReference: "Reference",
  transferDetailsSourceWallet: "From wallet",
  transferDetailsStatus: "Status",
  transferDetailsTargetWallet: "To wallet",
  transferDetailsTitle: "Transfer details",
  transferDetailsUpdatedAt: "Updated at",
  transferFundsAmount: "Amount ({{currency}})",
  transferFundsButton: "Make Transfer",
  transferFundsConversionInfo:
    "The source and target currencies differ, so this will be processed as a conversion. The exact received amount and rate are only known after execution.",
  transferFundsEstimate: "Estimated received ≈ {{value}}",
  transferFundsEstimateError:
    "Couldn't load the exchange rate. The transfer can still be submitted.",
  transferFundsEstimateLoading: "Calculating estimated amount…",
  transferFundsFailure: "Failed to submit transfer. Please try again.",
  transferFundsNote: "Note",
  transferFundsNotePlaceholder: "e.g. rebalance",
  transferFundsRate: "Rate: 1 {{from}} ≈ {{rate}} {{to}}",
  transferFundsSource: "From wallet",
  transferFundsSubmit: "Transfer",
  transferFundsSuccess: "Transfer submitted.",
  transferFundsTarget: "To wallet",
  transferFundsTitle: "Transfer funds",
  transfersListAmountIn: "Amount sent",
  transfersListAmountOut: "Amount received",
  transfersListCreatedAt: "Created",
  transfersListEmpty: "No transfers yet",
  transfersListFrom: "From",
  transfersListKind: "Kind",
  transfersListStatus: "Status",
  transfersListTitle: "Transfers",
  transfersListTo: "To",
  transfersTab: "Transfers",
  txDetails: "Tx Details",
  txHash: "Tx Hash",
  txState: "State",
  view: "View",
  vx2ProductDisabled: "VX2 product is not enabled",
  vx2ProductDisabledDescription: "Please contact sales to enable this feature.",
  walletAddress: "Wallet Address",
  walletBalance: "Wallet Balance",
  walletBalanceAlreadyTarget: "Already the Target Wallet",
  walletBalanceCrypto: "Crypto Wallets",
  walletBalanceDescription:
    "View live wallet balances for this customer. Click on wallet to show more.",
  walletBalanceError: "Error loading balance",
  walletBalanceFiat: "Fiat Wallets",
  walletBalanceNoWallets: "No wallets found for this customer.",
  walletBalanceNoWalletsHeader: "No Wallets",
  walletBalanceRefresh: "Refresh Balances",
  walletBalanceSetAsTarget: "Set as Target Wallet",
  walletBalanceTargetSetError: "Failed to set target wallet. Please try again.",
  walletBalanceTargetSetSuccess: "Target wallet updated successfully",
  walletBalanceTargetWallet: "Target Wallet",
  walletBalanceTitle: "Wallet Balances",
  walletDetailAccountHolder: "Account Holder",
  walletDetailAccountNumber: "Account Number",
  walletDetailBalance: "Balance",
  walletDetailBank: "Bank",
  walletDetailBankAccount: "Bank Account Details",
  walletDetailCapabilities: "Capabilities",
  walletDetailCryptoAddress: "Crypto Address Details",
  walletDetailPaymentReference: "Payment Reference",
  walletDetailProtocol: "Protocol",
  walletDetailsCardTitle: "Wallet details",
  walletDetailsFieldAccountHolder: "Account holder",
  walletDetailsFieldAccountNumber: "Account number",
  walletDetailsFieldAddress: "Address",
  walletDetailsFieldBalance: "Balance",
  walletDetailsFieldBic: "BIC / SWIFT",
  walletDetailsFieldId: "ID",
  walletDetailsFieldProtocol: "Protocol",
  walletDetailStatus: "Status",
  walletDetailSymbol: "Symbol",
  walletNameLabel: "Description",
  walletNameTooLong: "Name must be at most 100 characters.",
  walletNameUpdateFailure: "Failed to update wallet name. Please try again.",
  walletNameUpdateSuccess: "Wallet name updated successfully.",
  walletSettlementAddTime: "Add time",
  walletSettlementConfigure: "Configure settlement",
  walletSettlementConfigureDescription:
    "Configure beneficiary, destination, reserve amount and settlement schedule for this wallet.",
  walletSettlementConfigureTitle: "Configure settlement",
  walletSettlementDestinationCardDescription:
    "Choose the beneficiary and target account or wallet for settlements from this wallet.",
  walletSettlementDestinationCardTitle: "Destination",
  walletSettlementDisable: "Disable",
  walletSettlementEdit: "Edit configuration",
  walletSettlementEditTitle: "Edit settlement",
  walletSettlementEnable: "Enable",
  walletSettlementReserveCardDescription:
    "Configure the amount that should be retained when settling this wallet.",
  walletSettlementReserveCardTitle: "Reserve",
  walletSettlementRunNow: "Run now",
  walletSettlementScheduleCardDescription:
    "Configure the times when settlements should run automatically.",
  walletSettlementScheduleCardTitle: "Schedule",
  walletSettlementSettings: "Settlement settings",
  walletsListBalance: "Balance",
  walletsListCount: "{{used}}/{{limit}} wallets",
  walletsListEmptyDescription: "There are no wallets for this customer yet.",
  walletsListEmptyHeader: "No wallets",
  walletsListStatusActive: "Active",
  walletsListStatusCreating: "Creating…",
  walletsListStatusCreatingTooltip:
    "This wallet is still being created. This can take a moment — the list refreshes automatically.",
  walletsListStatusError: "Error",
  walletsListTargetWallet: "Target wallet",
  walletsListType: "Type",
  walletsListTypeCrypto: "Crypto",
  walletsListTypeFiat: "Fiat",
  walletsRowExpandedDestination: "Destination",
  walletsRowExpandedReserve: "Reserve",
  walletsRowExpandedScheduleTimes: "Schedule times",
  walletsRowExpandedSettleAll: "Settle entire balance",
  walletsRowExpandedSettlementStatus: "Settlement",
  walletsRowExpandedStatusDisabled: "Disabled",
  walletsRowExpandedStatusEnabled: "Enabled",
  walletsTabCrypto: "Crypto Wallets",
  walletsTabFiat: "Fiat Wallets",
};
